/**
 * Canonical Cognitory workspace entry navigation helpers.
 * Query parameters are untrusted selection requests only; backend access remains authoritative.
 */

const V2_ID_PATTERN = /^[a-zA-Z][a-zA-Z0-9_-]*$/;

export const COGNITORY_CANONICAL_WORKSPACE_PATH = "/" as const;

export const COGNITORY_WORKSPACE_ID_QUERY_PARAM = "cognitoryId" as const;

export function isValidCognitoryWorkspaceId(cognitoryId: string): boolean {
  const trimmed = String(cognitoryId ?? "").trim();
  if (
    trimmed.length === 0 ||
    trimmed.length > 128 ||
    trimmed.includes("..") ||
    trimmed.includes("/") ||
    trimmed.includes("\\") ||
    trimmed.includes(":") ||
    trimmed.includes("?") ||
    trimmed.includes("#")
  ) {
    return false;
  }
  return V2_ID_PATTERN.test(trimmed);
}

export function buildCanonicalCognitoryWorkspacePath(
  cognitoryId: string,
): string {
  if (!isValidCognitoryWorkspaceId(cognitoryId)) {
    throw new Error("invalid cognitory workspace id");
  }
  return `${COGNITORY_CANONICAL_WORKSPACE_PATH}?${COGNITORY_WORKSPACE_ID_QUERY_PARAM}=${encodeURIComponent(cognitoryId)}`;
}

export function parseRequestedCognitoryWorkspaceId(
  search: string,
): string | null {
  const raw = new URLSearchParams(search).get(
    COGNITORY_WORKSPACE_ID_QUERY_PARAM,
  );
  if (!raw || !isValidCognitoryWorkspaceId(raw)) {
    return null;
  }
  return raw;
}

export function stripCognitoryWorkspaceRequestParam(
  pathname: string,
  search: string,
): string {
  const params = new URLSearchParams(search);
  params.delete(COGNITORY_WORKSPACE_ID_QUERY_PARAM);
  const remainder = params.toString();
  return remainder ? `${pathname}?${remainder}` : pathname;
}
